import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { EmphasisLines } from '../EmphasisLines';
import { reuseMoments, valueClosing } from '../../data/salesContent';
export function ReuseSection() {
  return <PageSection labelledBy="reuse-title" className="bg-carbon-900" data-id="element-162" data-mp="2ocutudsjnkk4">
      <SectionHeading id="reuse-title" title="Usalo una y otra vez" subtitle="Este sistema no está pensado para leerlo una sola vez." data-id="element-163" data-mp="2jj9v2jj4mmjv" />
      <p className="mt-6 text-center text-base font-semibold text-carbon-200 md:text-[17px]" data-id="element-164" data-mp="2xdawjl1gqnnx">Volvé cuando:</p>
      <ul className="mx-auto mt-4 grid max-w-2xl gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-165" data-mp="379m6i4dkz1f7">
        {reuseMoments.map(m => <li key={m} className="flex items-start gap-2.5 text-base text-carbon-300" data-id="element-166" data-mp="32asu6fa15ggm">
            <span className="mt-2.5 h-1.5 w-1.5 shrink-0 bg-accent-500" aria-hidden="true" data-id="element-167" data-mp="1cvlarsdbuujc" />
            {m}
          </li>)}
      </ul>
      <EmphasisLines lines={valueClosing} className="mt-10" data-id="element-168" data-mp="17xbgdjzffxys" />
    </PageSection>;
}